<a class="pure-visible-xs close link" (click)="close()">
  <i class="arrow left large icon"></i>
</a>
<div class="ui pure-visible-xs no border top right attached basic label">
  {{ index + 1 }} / {{ imageList.length }}
</div>
<div *ngIf="this.imageList.length != 0">
  <swiper [config]="galleryTopSwiperConfig" [(index)]="index">
    <ng-container *ngFor="let screenimg of imageList">
      <div class="gallaryimg">
        <img class="ui fluid image" src="{{ screenimg.url }}" />
      </div>
    </ng-container>
  </swiper>
</div>
